import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, InputBase, IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';

const invoiceData = [
  { inv: 'INV-3072', vendor: 'BioGen', amt: '₹70,000', due: '20 Aug 2026', days: 2, status: 'pending' },
  { inv: 'INV-3075', vendor: 'Vedica Store', amt: '₹50,000', due: '21 Aug 2026', days: 3, status: 'pending' },
  { inv: 'INV-3067', vendor: 'AHB Pharma', amt: '₹1,60,000', due: '10 Sep 2026', days: 23, status: 'pending' },
  { inv: 'INV-3070', vendor: 'HealthCorp', amt: '₹88,500', due: '25 Sep 2026', days: 38, status: 'pending' },
  { inv: 'INV-3063', vendor: 'Vedica Store', amt: '₹1,18,000', due: '23 Aug 2026', days: 5, status: 'pending' },
  { inv: 'INV-3060', vendor: 'BioGen', amt: '₹92,000', due: '18 Aug 2026', days: 0, status: 'pending' },
  { inv: 'INV-3044', vendor: 'MediLife Ltd', amt: '₹2,10,000', due: '14 Aug 2026', days: -4, status: 'overdue' },
  { inv: 'INV-3021', vendor: 'AHB Pharma', amt: '₹1,45,000', due: '02 Aug 2026', days: -16, status: 'overdue' },
  { inv: 'INV-3009', vendor: 'XYZ Chemicals', amt: '₹78,500', due: '08 Aug 2026', days: -10, status: 'overdue' },
  { inv: 'INV-2950', vendor: 'XYZ Chemicals', amt: '₹74,000', due: '30 Jun 2026', days: -49, status: 'overdue' },
  { inv: 'INV-2940', vendor: 'BioGen', amt: '₹43,600', due: '05 Jun 2026', days: -74, status: 'overdue' },
  { inv: 'INV-2905', vendor: 'MediLife Ltd', amt: '₹1,16,300', due: '10 May 2026', days: -100, status: 'overdue' },
];

const invoiceStatusColors = {
  paid: 'green',
  pending: 'amber',
  overdue: 'red',
};

export default function InvoiceTableCard() {
  return (
    <Box className="card" style={{ minHeight: '400px' }}>
      <div className="card-head">
        <h3 className="card-title" id="finInvTitle">Invoices — Aug 2026</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <Box sx={{ position: 'relative', maxWidth: 200 }}>
            <SearchIcon sx={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-mut)', fontSize: 18 }} />
            <InputBase
              placeholder="Search invoices..."
              sx={{ width: '100%', '& input': { paddingLeft: 32, fontSize: 12, height: 32 } }}
              id="finInvSearch"
            />
          </Box>
          <Tooltip title="Filters">
            <IconButton size="small" aria-label="filters">
              <FilterListIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Invoice</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell align="right">Amount</TableCell>
              <TableCell align="right">Due Date</TableCell>
              <TableCell align="right">Days</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="finInvBody">
            {invoiceData.map((row) => (
              <TableRow key={row.inv} hover className="row-click" onClick={() => window.openS360?.(row.vendor)}>
                <TableCell>{row.inv}</TableCell>
                <TableCell><span className="vendor-link">{row.vendor}</span></TableCell>
                <TableCell align="right">{row.amt}</TableCell>
                <TableCell align="right">{row.due}</TableCell>
                <TableCell align="right">{row.days >= 0 ? row.days : Math.abs(row.days)}</TableCell>
                <TableCell>
                  <span className={`pill ${invoiceStatusColors[row.status]}`}>
                    {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: 12, fontSize: '12px', color: 'var(--text-sec)' }} id="finInvCount">
        {invoiceData.length} shown
      </div>
    </Box>
  );
}
